export enum PromotionsRequestType {
  HOTEL = 'Hotel',
  EXPEDIA_HOTEL = 'ExpediaHotel',
  TOUR = 'Tour',
  DOMESTIC_TOUR = 'DomesticTour',
  CRUISE = 'Cruise',
  PERSONAL_HOTEL_RECOMMENDATIONS = 'PersonalHotelRecommendations',
}
